import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import BidSuccess from "../../assets/bid_success.svg";


const  CongratsHeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
`

const InfoSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(255, 255, 255, 0.45);
`

const InfoSpan2 = styled.span`  
  font-family: IBM Plex Mono;a
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const LeftButtonDiv = styled.div`
  width: 193px;
  height: 44px;
  background: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
`

const LeftButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const RightButtonDiv = styled.div`
  width: 193px;
  height: 44px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: center;
`


const RightButtonTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`


export default function SuccessBidComponent(props) {
    
    return (
	<>
	    <div style={{display:"flex", flexDirection: "column", alignItems: "center"}}>
		<img src={BidSuccess} style={{width:42, height:42}} />
		<CongratsHeaderSpan style={{marginTop:22}}>
		    Congrats, your bid <br/>
		    is placed
		</CongratsHeaderSpan>
		<InfoSpan style={{marginTop:17}}>
		    Keep in mind, we charge only if you Win.
		</InfoSpan>
		<InfoSpan2 style={{marginTop:10}}>
		    You can always bid more<br/>
		</InfoSpan2>
		<div style={{display:"flex", marginTop:24}}>
		    <LeftButtonDiv
			onClick={() =>{props.handleModalCloseEvent()}}>
			<LeftButtonTextSpan>
			    GOT IT
			</LeftButtonTextSpan>
		    </LeftButtonDiv>
		</div>
	    </div>
	</>
    );
}

